<a
  [routerLink]="['/measurements']"
  routerLinkActive="active"
>
  <span class="text">{{ 'Виміри' | translate }}</span>
</a>
